export default __webpack_public_path__ + "static/media/summary-stats-completed.683d358f.svg";